/**
 * Адрес фрейма сервиса зарплаты для сотрудника, чья карточка открыта.
 * jwt и branchId IframePage добавляет сам, сохраняя параметры адреса.
 * Пустой или некорректный адрес сервиса — '' (вкладка не показывается).
 */
export const getSalaryFrameHost = (salaryHost: string, userId: number) => {
  if (!salaryHost || !userId) return '';

  try {
    const url = new URL(salaryHost);

    url.searchParams.set('userId', String(userId));

    return url.toString();
  } catch {
    return '';
  }
};
